import React from "react";
import Typography from "@material-ui/core/Typography";
const PurchaseRequest = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Purchase Request
      </Typography>
      <Typography paragraph variant="h5">
        Request material purchase to achieve effective supply chain
      </Typography>
      <Typography paragraph variant="body1">
        Purchase Request is one of the features under the Procurement module to
        perform purchasing transactions particularly to request the material
        needed by the company operation to the procurement team. It contains any
        information regarding the purchase requestor, proposed currency &
        exchange rate used for the transaction, purchase note, and the request
        items detail.
      </Typography>
      <Typography paragraph variant="h5" className="mt-5">
        How it works
      </Typography>
      <Typography paragraph variant="body1">
        The first information displayed on this feature is the Purchase Request
        list. It is displayed like a table that contains download functions,
        sort, filter, and global search on the header area, and contains data
        navigation and refresh function on the footer area. The data column that
        appears in this table list are listed below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Request ID</b>
        <br />
        Indicates the ID of the Purchase Request.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Warehouse Name</b>
        <br />
        Indicates the purchase requestor of the Purchase Request.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Request Date</b>
        <br />
        Indicates the request date of the Purchase Request.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Order Status</b>
        <br />
        Indicates the purchase status of the Purchase Request. There are 3
        statuses: Unordered, Partially Ordered, and Fully Ordered.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Valuation Price</b>
        <br />
        Indicates the valuation price of the Purchase Request.
      </Typography>
      <Typography paragraph variant="body1">
        Apart from the column appearing on the table list, there are more
        columns available on each row by clicking the expand button on the left
        side of each data.
      </Typography>
      <Typography paragraph variant="body1">
        Besides, there are 3 buttons and 1 approval indicator that appear on
        each row of Purchase Request data with specific conditions explained
        below:
      </Typography>
      <Typography paragraph variant="body1">
        <b>Edit Purchase Request</b>
        <br />
        This button only appears if the Purchase Order status is 'Unordered' and
        the approval indicator is not 'Document Waiting For Approval'. It is
        used to edit the Purchase Request data.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Purchase Request Detail</b>
        <br />
        This button is used to navigate to the Purchase Request detail which
        contains some tabs with details below:
        <ul>
          <li>
            <b>Basic Info</b> : This tab is to display the Purchase Request
            data.
          </li>
          <li>
            <b>Attachments</b> : This tab is to display any Attachments related
            to the Purchase Request.
          </li>
          <li>
            <b>Notes</b> : This tab is to display any Notes related to the
            Purchase Request.
          </li>
        </ul>
        When opening the Purchase Request detail, the information is in
        non-editable mode.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Delete Purchase Request</b>
        <br />
        This button only appears if the Purchase Order status is 'Unordered' and
        the approval indicator is not 'Document Waiting For Approval'. It is
        used to delete the Purchase Request data. The Purchase Request data is
        undeletable once it has relations with other documents.
      </Typography>
      <Typography paragraph variant="body1">
        <b>Approval Indicator</b>
        <br />
        The Purchase Request document could have an approval flow if it is
        configured. The approval indicator appears as an icon after the document
        ID. There are 4 approval indicators: Document No Need Approval, Document
        Waiting For Approval, Document Approved, and Document Rejected.
      </Typography>
    </React.Fragment>
  );
};

export default PurchaseRequest;
